document.querySelectorAll('.team-slider').forEach(section => {
  const nextArrow = jQuery(section).find('.team-slider-next');
  const prevArrow = jQuery(section).find('.team-slider-prev');


  if (jQuery('#teamSlider').length) {
    jQuery('#teamSlider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false,
      prevArrow: jQuery('.team-slider-prev'),
      nextArrow: jQuery('.team-slider-next'),
      infinite: false,
      responsive: [
        {
          breakpoint: 1160,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

    var height = 200;
    jQuery(document).ready(function () {
      jQuery(window).on('resize load', function () {
        jQuery('.team-slider .slick-slide .card').each(function () {
          if (jQuery(this).height() > height) {
            height = jQuery(this).height();
          }
        });

        var size = height + 80;

        jQuery('.team-slider .slick-slide .card').css('height', size + 'px');
      });
    });
  }

});



const toggles = document.querySelectorAll('.team-slider [data-open]');


toggles.forEach(toggle => {
  toggle.addEventListener('click', toggleInfo);
});

/**
 * @param {Event} e
 *
 * @return void
 */
function toggleInfo(e) {
  // @ts-ignore The handler is only used on HTML Elements...
  const teamCard = e.currentTarget.closest('[data-active]');
  toggleActive(teamCard);
}

/**
 * @param {HTMLElement} el
 *
 * @return void
 */
function toggleActive(el) {
  el.setAttribute('data-active', el.dataset.active === 'true' ? 'false' : 'true');
}
